module.exports = __webpack_public_path__ + "img/cover_pressalit_2.4b56b9bf.jpg";